import { Input } from '@/components/ui/input';

function Additional_information_turn({
    data,
    formValues,
    setFormValues,
}: {
    data: string[];
    formValues: { [key: string]: string };
    setFormValues: (s: React.SetStateAction<{ [key: string]: string }>) => void;
}) {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    return (
        data &&
        data.length > 0 && (
            <form className="bg-white p-4 rounded-2xl">
                <p className="text-blue text-sm md:!text-base">
                    فرم درخواست پزشک اطلاعات تکمیلی
                </p>
                <div className="grid-cols-1 grid gap-2">
                    <div className="grid gap-x-4 gap-y-4 pt-5 md:!grid-cols-2">
                        {data.map(
                            (item: string, index: number) =>
                                (item === 'name' ||
                                    item === 'father_name' ||
                                    item === 'basic_ins' ||
                                    item === 'complete_ins') && (
                                    <div
                                        key={index}
                                        className="w-full flex-col flex gap-2"
                                    >
                                        <label
                                            htmlFor={item}
                                            className="mr-2 font-medium text-xs md:!text-sm"
                                        >
                                            {item === 'name' &&
                                                'نام ( الزامی )'}
                                            {item === 'father_name' &&
                                                'نام پدر ( الزامی )'}
                                            {item === 'basic_ins' &&
                                                'بیمه ( الزامی )'}
                                            {item === 'complete_ins' &&
                                                'بیمه تکمیلی ( الزامی )'}
                                        </label>
                                        <Input
                                            type="text"
                                            name={item}
                                            id={item}
                                            className="py-2 px-3 border-gray-300 focus:border-gray-300 focus:!ring-0 outline-0 rounded-2xl !bg-white w-full flex"
                                            value={formValues[item] || ''}
                                            onChange={handleChange}
                                        />
                                    </div>
                                ),
                        )}
                    </div>
                    <div className="pt-2 flex flex-col gap-2">
                        {data.map(
                            (item: string, index: number) =>
                                item === 'address' && (
                                    <div
                                        key={index}
                                        className="flex gap-2 flex-col"
                                    >
                                        <label
                                            htmlFor={item}
                                            className="mr-2 font-medium text-xs md:!text-sm"
                                        >
                                            آدرس ( الزامی )
                                        </label>
                                        <input
                                            type="text"
                                            name={item}
                                            id={item}
                                            className="py-2 px-3 border rounded-2xl !bg-white  w-full border-gray-300 focus:border-gray-300 outline-0"
                                            value={formValues[item] || ''}
                                            onChange={handleChange}
                                        />
                                    </div>
                                ),
                        )}
                    </div>
                </div>
            </form>
        )
    );
}

export default Additional_information_turn;
